import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export interface barcodeLabelInterface {
    barcode: string
    title: string
    count: number
}

export interface FnskuLabel {
    fnsku: string
    title: string
    condition: string
    count: number
    expiryDate: string | null
}

export interface FnskuOption {
    fnsku: string
    channelId?: number
    channelName?: string
}

export interface FnskuLabelPrintItem {
    productId?: number
    title: string
    condition: string
    count: number
    expiryDate: string | null
    fnskuOptions: FnskuOption[]
}

export interface FnskuLabelWithOptions extends FnskuLabelPrintItem, FnskuLabel {
}

const isFnskuLabel = (label: barcodeLabelInterface | FnskuLabel): label is FnskuLabel => {
    return 'fnsku' in label;
};

const isBarcodeLabel = (label: barcodeLabelInterface | FnskuLabel): label is barcodeLabelInterface => {
    return !isFnskuLabel(label);
};

export default (axios: AxiosInstance = baseAxios): { isFnskuLabel: (label: barcodeLabelInterface | FnskuLabel) => label is FnskuLabel; isBarcodeLabel: (label: barcodeLabelInterface | FnskuLabel) => label is barcodeLabelInterface; requestFnskuLabels: (labels: FnskuLabel[]) => Promise<void>; requestBarcodeLabels: (labels: barcodeLabelInterface[]) => Promise<void>; } => ({
    isFnskuLabel,
    isBarcodeLabel,

    requestFnskuLabels: async (labels: FnskuLabel[]): Promise<void> => {
        return await axios.post('/api/labels/fnsku', { labels });
    },

    requestBarcodeLabels: async (labels: barcodeLabelInterface[]): Promise<void> => {
        await axios.post('/api/labels/barcode', { labels });
    },
});
